const quiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "quiz",
    items: [
      { id: "q1", question: "Cén lá a thagann roimh Dé Máirt? ", answers: ["Dé Luain"], image: null },
      { id: "q2", question: "Cén lá a thagann tar éis Dé Máirt? ", answers: ["Céadaoin"], image: null },
      { id: "q3", question: "Cén lá a thagann roimh an Aoine? ", answers: ["Déardaoin"], image: null },
      { id: "q4", question: "Is iad Dé Sathairn agus Dé Domhnaigh an ... ", answers: ["deireadh seachtaine"], image: null },
      { id: "q5", question: "Cén lá a thagann roimh Dé Sathairn ", answers: ["Dé Aoine"], image: null },
      { id: "q6", question: "Cén lá a thagann tar éis Dé Máirt? ", answers: ["Dé Céadaoin"], image: null },
      { id: "q7", question: "Cén lá a thagann roimh Dé Máirt? ", answers: ["Dé Luain"], image: null },
      { id: "q8", question: "Cén lá a thagann tar éis Dé Sathairn? ", answers: ["Dé Domhnaigh"], image: null },
      { id: "q9", question: "Cén lá a thagann roimh Dé Máirt? ", answers: ["Dé Luain"], image: null },
      { id: "q10", question: "Bíonn ___ lá sa tseachtain ", answers: ["7", "seacht"], image: null },
    ],
  },
  botId: "nualang.quiz.0.0.1",
  botName: "quiz",
  description: "quiz_desc",
  difficulty: "ALL",
  learnLang: "irish",
  name: "Joey",
  botAvatar:
    "https://d3g1pegw1dz0u6.cloudfront.net/eyJidWNrZXQiOiJsZXRzdGFsay1pbWFnZXMtZGV2Iiwia2V5IjoiYXZhdGFycy8wMTAtZ2lybC0xLnBuZyJ9",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-question-circle?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Fáilte go dtí an tráth na gceist
Óstáil ag Joey.

An bhfuil laethanta na seachtaine ar eolas agat?

Abair "Dia duit" le Joey chun tosú.`,
  voice: "Joey",
  versionQuestion: "Cé mhéad ceist a bheadh ​​uait sa teimpléad seo?",
};

export default quiz;
